import {cleanEntity} from "@mytour/platform";
import {
  type CreateWorkerPayload,
  type TeamMember,
  type UpdateWorkerPayload,
  WorkerSchema,
} from "@mytour/shared";
import axios from "axios";

export const teamWorkerApiService = {
  async createWorker(payload: CreateWorkerPayload): Promise<TeamMember> {
    const result = await axios.post("api/team/workers/", cleanEntity(payload));
    return WorkerSchema.parse(result.data);
  },

  async updateWorker(workerId: string, payload: UpdateWorkerPayload): Promise<TeamMember> {
    const result = await axios.patch(`api/team/workers/${workerId}/`, cleanEntity(payload));
    return WorkerSchema.parse(result.data);
  },

  async activateWorker(workerId: string): Promise<void> {
    await axios.patch(`api/team/workers/${workerId}/activate`);
  },

  async deactivateWorker(workerId: string): Promise<void> {
    await axios.patch(`api/team/workers/${workerId}/deactivate`);
  },

  async deleteWorker(workerId: string): Promise<void> {
    await axios.delete(`api/team/workers/${workerId}/`);
  },

  async resendInvitation(workerId: string): Promise<void> {
    await axios.post(`api/team/workers/${workerId}/resend-invitation`);
  },

  async regeneratePassword(workerId: string): Promise<void> {
    await axios.patch(`api/team/workers/${workerId}/regenerate-password`);
  },
};
